export default function AccountCard() {
    return (<div className="relative">
        <div className="h-36 mx-5 text-white rounded-2xl bg-gradient-to-tr from-stone-500 to-slate-800 absolute top-0 left-0 right-0">
            <p className="px-5 pt-5">نقره ای</p>
            <p className="px-5 font-bold text-xl mt-3">102,000</p>
            <p className="px-5 text-xl">تومان</p>
        </div>

        <div className="h-36 me-5 ms-40 text-white rounded-2xl bg-gradient-to-bl from-indigo-500 from-10% via-sky-500 via-30% to-emerald-500 to-90% relative">
            <p className="px-5 pt-5">طلایی</p>
            <p className="px-5 font-bold text-xl mt-3">1,426,000</p>
            <p className="px-5 text-xl">تومان</p>
            <p className="px-5 text-sm text-end">ATMA-2067</p>
        </div>
    </div>);
}